<template>
  <div>
    <div
    class="vue-outages-by-utility-and-county-wrap">
      <div
      class="content-container">
        <b-spinner v-if="!tableRows || !tableRows.length" class="ajax-spinner"></b-spinner>
        <div
        class="list-container">
          <vue-scroll :ops="vueScrollOptions">
          <div class="list-container-inner">
            <vue-good-table
            styleClass="vtoutages-vgt-table"
            v-if="tableRows && tableRows.length"
            :rows="tableRows"
            :columns="tableColumns">
              <template slot="table-row" slot-scope="props">
                <span v-if="props.column.field == 'utility'">
                  <span class="utility-column">
                    <p class="name">{{props.row[props.column.field]}}</p>
                    <p class="as-of-date">{{props.row.asOfDateFormatted}}</p>
                  </span>
                </span>
              </template>
            </vue-good-table>
          </div>
          </vue-scroll>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import API from "@/services/api";
import { VueGoodTable } from 'vue-good-table';
import 'vue-good-table/dist/vue-good-table.css'

export default {
  name: "OutagesTableDesktop",
  components: {
    VueGoodTable,
  },
  data() {
    return {
      counties: [],
      utilityOutages: [],
      tableRows: [],
      vueScrollOptions: {
          bar : {
              size: '5px',
              opacity: 0.5,
              minSize: 0.25,
              keepShow: true,
              background: '#F0F0F0'
          }
      },
      tableColumns: [{label: 'Utility', field: 'utility', type: 'string', width: '80px'}]
    };
  },
  async created() {
    await this.GetData();

    if (!this.counties
      || !this.counties.length
      || !this.utilityOutages
      || !this.utilityOutages.length) {
        return;
    }

    this.buildTableColumns();
    this.buildTableRows();
    this.totalEachRow();
    this.buildTotalRow();
  },
  methods: {
    async GetData() {
        try {
            Promise.all([
            await API.GetCounties().then(counties => this.counties = counties || []),
            await API.GetUtilityOutagesWithCounties(null, true).then(outages => this.utilityOutages = outages || [])
            ]);
        } catch (err) {
            console.log("Unable to fetch county & utilityOutage data");
            console.log(err);
        }
    },
    buildTableColumns() {
      this.counties.forEach(county => {
        this.tableColumns.push({
          label: county.name,
          field: county.code,
          type: 'number',
          width: '55px'
        });
      });

      // add a total column
      this.tableColumns.push({
        label: 'Total',
        field: 'total',
        type: 'number',
        width: '55px'
      });
    },
    totalEachRow() {
      // for each table row
      this.tableRows.forEach(row => {
        // initialize the total count
        let total = 0;

        // for every column
        this.tableColumns.forEach(column => {
          // ignore 1st and last columns
          if (column.field === 'utility' || column.field === 'total') {return; }

          // update the total variable
          total += parseInt(row[column.field], 10);
        });

        // set the total for this row
        row.total = total;
      });
    },
    buildTotalRow() {
      const totalRow = {utility: 'Total',  total: 0};

      // for each county
      this.tableColumns.forEach(column => {
        // initialize the total count
        let total = 0;

        // ignore 1st and last columns
        if (column.field === 'utility') {return; }

        // for each row
        this.tableRows.forEach(row => {
          // update the total variable
          total += parseInt(row[column.field], 10);
        });

        // set the total for this column
        totalRow[column.field] = total;
      });

      // add this total row to the table rows
      this.tableRows.push(totalRow);
    },
    buildTableRows() {
      // for each utility outage
      this.utilityOutages.forEach(utilityOutage => {
        const row = {total: 0};
        row.utility = utilityOutage.name;

        row.asOfDateFormatted = `${moment(new Date(utilityOutage.asOfDate)).format('M/DD - h:mm a')}`;

        // for each county
        this.counties.forEach(county => {
          //initialize the row.county
          row[county.code] = 0;

          // if this utility outage has counties
          if (utilityOutage.counties && utilityOutage.counties.length) {
            // for each county that this utility has outages for
            utilityOutage.counties.forEach(uoCounty => {
              // if this utility outage county ID matches the current county ID
              if (uoCounty.countyId === county.countyId) {
                // for this row, XX county outages is this utility outage
                row[county.code] += parseInt(uoCounty.customerCount, 10);
              } else {
                // for this row, XX county outages is what it is, or 0
                row[county.code] = row[county.code] || 0;
              }
            });
          } else {
            // if this utility outage has no counties, enter 0
            row[county.code] = row[county.code] || 0;
          }
        });

        // add this row to the rows array
        this.tableRows.push(row);
      });
    }
  }
};
</script>
<style lang="scss" scoped>
@import "../../../assets/css/partials/_variables.scss";

.vue-outages-by-utility-and-county-wrap{
    position: relative;
    min-height: 500px;

    .ajax-spinner{
      position: absolute;
      top: 80px;
      left: 40%;
      height: 150px;
      width: 150px;
      color: #fbd850
    }

    ::v-deep .vgt-wrap{
      table {
        &.vtoutages-vgt-table{
          width: 100%;
          table-layout: fixed;
          border-collapse: collapse;
          border-spacing: 0;
          color: #333;
          font-weight: normal;
          background-color: $white;

          thead {
            border-bottom: 1px solid $greyTextTrans65;

            tr {
              th {
                position: relative;
                padding: 10px 0;
                text-align: center;
                font-weight: $xbold;
                font-size: 10px;
                background-color: $modalGrey;

                &:first-child{
                  padding-left: 10px;
                  text-align: left;
                }

                &.sortable{
                  &:before {
                    cursor: pointer;
                    content: "";
                    position: absolute;
                    height: 0;
                    width: 0;
                    right: 0;
                    top: 35%;
                    margin-bottom: -7px;
                    border-left: 5px solid transparent;
                    border-right: 5px solid transparent;
                    border-top: 5px solid #cfd3e0;
                  }

                  &:after {
                    cursor: pointer;
                    content: "";
                    position: absolute;
                    height: 0;
                    width: 0;
                    right: 0;
                    top: 35%;
                    margin-top: -7px;
                    border-left: 5px solid transparent;
                    border-right: 5px solid transparent;
                    border-bottom: 5px solid #cfd3e0;
                  }
                }
              }
            }
          }

          tbody {
            tr {
              border-bottom: 1px solid $greyTextTrans25;

              &:last-child{
                border: none;
                background-color: $modalGrey;
                font-weight: $xbold;
              }

              td {
                height: 28px;
                text-align: center;
                line-height: 28px;
                font-size: 10px;

                &:first-child{
                  position: relative;
                  padding-left: 10px;
                  text-align: left;
                  font-weight: $xbold;

                  .utility-column{
                    .name{
                      margin: 0 0 5px 0;
                      padding: 0;
                      line-height: 10px;
                    }

                    .as-of-date{
                      margin: 0;
                      padding: 0;
                      font-size: 8px;
                      line-height: 8px;
                      font-weight: $regular;
                    }
                  }
                }

                &:last-child{
                  position: relative;
                  padding-left: right;
                  font-weight: $xbold;
                }
              }
            }
          }
        }
      }
    }
}
</style>